/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_View_AllInputs */

const en_dashboard_view_all = /** @type {(inputs: Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View All`)
};

const es_dashboard_view_all = /** @type {(inputs: Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todo`)
};

/**
* | output |
* | --- |
* | "View All" |
*
* @param {Dashboard_View_AllInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_view_all = /** @type {((inputs?: Dashboard_View_AllInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_View_AllInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_view_all(inputs)
	return en_dashboard_view_all(inputs)
});